import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SALON } from "@/data/salon";

const Section = ({ id, title, children }) => (
    <section id={id} className="border-t border-linen pt-10 mt-10 first:border-t-0 first:pt-0 first:mt-0">
        <h2 className="font-serif text-2xl md:text-3xl text-ink">{title}</h2>
        <div className="mt-4 text-stone2 leading-relaxed space-y-4 text-base">{children}</div>
    </section>
);

export default function Privacy() {
    return (
        <div data-testid="privacy-page" className="bg-cream text-ink font-sans min-h-screen">
            <header className="border-b border-linen/60 bg-cream/85 backdrop-blur-xl sticky top-0 z-40">
                <div className="max-w-[900px] mx-auto px-5 md:px-10 h-[70px] flex items-center justify-between">
                    <Link
                        to="/"
                        data-testid="privacy-back-link"
                        className="inline-flex items-center gap-2 text-sm tracking-[0.12em] uppercase text-stone2 hover:text-ink transition-colors duration-300"
                    >
                        <ArrowLeft size={16} /> Torna al sito
                    </Link>
                    <span className="font-serif italic text-2xl">Moovie</span>
                </div>
            </header>

            <main className="max-w-[900px] mx-auto px-5 md:px-10 py-16 md:py-24">
                <p className="text-xs tracking-[0.25em] uppercase font-semibold text-sage">
                    Documento informativo
                </p>
                <h1 className="font-serif text-4xl md:text-6xl tracking-tight mt-4">
                    Privacy & Cookie Policy
                </h1>
                <p className="mt-6 text-stone2 leading-relaxed">
                    Ultimo aggiornamento: luglio 2026
                </p>

                <div className="mt-14">
                    <Section title="1. Titolare del trattamento">
                        <p>
                            Il titolare del trattamento dei dati è{" "}
                            <strong>{SALON.legalName}</strong>, con sede in {SALON.address},
                            telefono {SALON.phoneDisplay}.
                        </p>
                    </Section>

                    <Section title="2. Dati raccolti e finalità">
                        <p>
                            Questo sito non raccoglie dati personali tramite moduli di
                            contatto. La prenotazione avviene esclusivamente tramite
                            telefono al numero {SALON.phoneDisplay}.
                        </p>
                        <p>
                            I dati che ci fornisci volontariamente via telefono
                            (nome, numero di telefono, servizio richiesto) sono utilizzati
                            esclusivamente per gestire il tuo appuntamento e non vengono
                            ceduti a terzi né utilizzati per finalità di marketing senza il
                            tuo consenso esplicito.
                        </p>
                    </Section>

                    <Section title="3. Base giuridica e conservazione">
                        <p>
                            Il trattamento si fonda sull'esecuzione di misure precontrattuali
                            richieste dall'interessato (art. 6, par. 1, lett. b GDPR). I dati
                            di contatto sono conservati per il tempo necessario alla gestione
                            del rapporto e comunque non oltre 24 mesi dall'ultimo contatto.
                        </p>
                    </Section>

                    <Section id="cookie" title="4. Cookie Policy">
                        <p>
                            Questo sito utilizza esclusivamente <strong>cookie tecnici</strong>,
                            necessari al funzionamento delle pagine e alla memorizzazione
                            della tua preferenza sul banner cookie (conservata localmente sul
                            tuo dispositivo, senza invio a server).
                        </p>
                        <p>
                            Eventuali strumenti di misurazione statistica in forma anonima e
                            aggregata vengono attivati solo previa accettazione tramite il
                            banner. Puoi modificare la tua scelta in qualsiasi momento
                            cancellando i dati del sito dal tuo browser.
                        </p>
                    </Section>

                    <Section title="5. Diritti dell'interessato">
                        <p>
                            Ai sensi degli artt. 15–22 del GDPR, hai diritto di accedere ai
                            tuoi dati, chiederne la rettifica, la cancellazione, la
                            limitazione del trattamento e di opporti al trattamento stesso.
                            Per esercitare i tuoi diritti puoi contattarci al numero{" "}
                            {SALON.phoneDisplay} o di persona presso la sede del salone.
                        </p>
                        <p>
                            Hai inoltre diritto di proporre reclamo al Garante per la
                            protezione dei dati personali (www.garanteprivacy.it).
                        </p>
                    </Section>
                </div>
            </main>
        </div>
    );
}
